@if (tenantContextService.isLoading()) {
<div class="loading"><app-loading-spinner [strokeWidth]="5"></app-loading-spinner></div>
} @else if (tenantContextService.hasTenantError()) {
<div class="error-message">
    <mat-icon>warning</mat-icon>
    <p>Failed to load tenant. Please try again later</p>
</div>
} @else {
<div class="tenant-container">
    <div class="tenant-header-container">
        <div class="tenant-name-container">
            <div class="tenant-title-container">
                <div class="tenant-title-row">
                    <h1 class="tenant-title">{{tenantContextService.tenant()?.tenantAlias}}</h1>
                </div>
                <div class="tenant-id-container">
                    <div class="tenant-id-badge">
                        <span class="tenant-id-value">{{tenantContextService.tenant()?.tenantId}}</span>

                    </div>
                    <button mat-icon-button class="copy-button" matTooltip="Copy Tenant ID" (click)="copyTenantId()">
                        <mat-icon>content_copy</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <div class="tenant-tab-bar-container">
            <div class="tab-bar">
                <div class="tab-indicator" [style.transform]="'translateX(' + indicatorPosition() + 'px)'"
                    [style.width]="indicatorWidth() + 'px'"></div>
                <button mat-fab extended #overviewBtn class="tab-button" [class.active]="selectedTab() === 'overview'"
                    (click)="selectTab('overview')" disableRipple>Overview</button>
                <button mat-fab extended #dataLakesBtn class="tab-button" [class.active]="selectedTab() === 'dataLakes'"
                    (click)="selectTab('dataLakes')" disableRipple>Data Lakes</button>
                <button mat-fab extended #workspacesBtn class="tab-button"
                    [class.active]="selectedTab() === 'workspaces'" (click)="selectTab('workspaces')"
                    disableRipple>Workspaces</button>
                <button mat-fab extended #catalogsBtn class="tab-button" [class.active]="selectedTab() === 'catalogs'"
                    (click)="selectTab('catalogs')" disableRipple>Catalogs</button>
            </div>
        </div>
    </div>
    <div class="tenant-body-container">
        @if (selectedTab() === 'overview') {
        <app-overview-tab></app-overview-tab>
        } @else if (selectedTab() === 'dataLakes') {
        <app-data-lakes-tab></app-data-lakes-tab>
        } @else if (selectedTab() === 'workspaces') {
        <app-workspaces-tab></app-workspaces-tab>
        } @else if (selectedTab() === 'catalogs') {
        <app-catalogs-tab></app-catalogs-tab>
        }
    </div>
</div>
}